import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SharedFacade } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-add-edit-sso-group',
  templateUrl: './add-edit-sso-group.component.html',
  styleUrls: ['./add-edit-sso-group.component.scss'],
})
export class AddEditSsoGroupComponent {
  @Output() saveSSOGroupEvent = new EventEmitter<any>();
  ssoGroupForm!: FormGroup;
  submitted = false;
  ssoData: any;
  headerName: any;
  inputFieldDesc: any;
  validationText: any;
  userRoles: any;
  selectRoleName: any;
  groupId: unknown;

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    public sharedFacade: SharedFacade,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    this.ssoData = this.modal?.modalService?.config?.initialState?.['ssoData'];
    this.headerName = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.groupId = this.modal?.modalService?.config?.initialState?.['groupId'];
    this.userRoles = this.ssoData.userRoles;
    this.ssoGroupForm = this.formBuilder.group({
      azureAdGroup: [this.ssoData.groupId || '', [Validators.required, Validators.maxLength(50)]],
      userRole: [this.ssoData.roleId || null, Validators.required],
    });
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    if (this.ssoGroupForm.valid) {
      const data = {
        groupId: this.ssoGroupForm.controls['azureAdGroup'].value,
        roleId: this.ssoGroupForm.controls['userRole'].value,
        userRole: this.selectRoleName,
        organizationId: this.cookieService.get('organizationId'),
        id: this.groupId || 0,
      };
      this.saveSSOGroupEvent.emit(data);
      this.modal.close();
    }
  }

  selectRoleId(event: any) {
    this.selectRoleName = event.roleName;
  }

  commonInputSearch(term: string, item: any) {
    return item.roleName?.toLowerCase().includes(term.toLowerCase());
  }
}
